import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13.5 19h-8.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4","key":"svg-0"}],["path",{"d":"M22 22l-5 -5","key":"svg-1"}],["path",{"d":"M17 22l5 -5","key":"svg-2"}]]

const IconFolderX = createReactComponent('outline', 'folder-x', 'FolderX', __iconNode);

export default IconFolderX;